/* tslint:disable */
/* eslint-disable */
/**
 * Indices API
 * Référentiel des indices de branche et de leurs valeurs datées
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Valeur d'un indice à partir d'une date de début de validité.
 * @export
 * @interface ValeurIndiceDto
 */
export interface ValeurIndiceDto {
    /**
     * 
     * @type {string}
     * @memberof ValeurIndiceDto
     */
    id: string;
    /**
     * Date calendaire "yyyy-MM-dd", début de validité. Déclarée en chaîne et non en date-time à dessein : le back ignore l'heure et ne convertit aucun fuseau. La sérialiser en Date la ferait basculer d'un jour selon le fuseau du poste.
     * @type {string}
     * @memberof ValeurIndiceDto
     */
    startDate?: string;
    /**
     * Valeur de l'indice, jusqu'à trois décimales (numeric(18,3) côté base).
     * @type {number}
     * @memberof ValeurIndiceDto
     */
    value?: number;
}

/**
 * Check if a given object implements the ValeurIndiceDto interface.
 */
export function instanceOfValeurIndiceDto(value: object): value is ValeurIndiceDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function ValeurIndiceDtoFromJSON(json: any): ValeurIndiceDto {
    return ValeurIndiceDtoFromJSONTyped(json, false);
}

export function ValeurIndiceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValeurIndiceDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'startDate': json['startDate'] == null ? undefined : json['startDate'],
        'value': json['value'] == null ? undefined : json['value'],
    };
}

export function ValeurIndiceDtoToJSON(json: any): ValeurIndiceDto {
    return ValeurIndiceDtoToJSONTyped(json, false);
}

export function ValeurIndiceDtoToJSONTyped(value?: ValeurIndiceDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'startDate': value['startDate'],
        'value': value['value'],
    };
}

